import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@material-ui/icons';
import VariantService from '../../../../services/VariantService/VariantService';
import Spinner from '../../../../components/Spinner/Spinner';
import Card from './Card';
import './Variant.css';
/**
 * @Description This function returns Variant section.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Variant ({ state, setState }) {
    const { t } = useTranslation();
    const label = 'CONTENT.VARIANTS.';
    const [dataFirst, setDataFirst] = useState([]);
    const [loading, setLoading] = useState(true);
    // const [dataSecond, setDataSecond] = useState([]);

    useEffect(() => {
        fetchData();
    }, [state['destination_app'].length]);

    const fetchData = async () => {
        setLoading(true);
        let categories = '', sources = '', dest = '';
        for (const item of state.category) {
            categories += item.id + ',';
        }
        for (const item of state.source_app) {
            sources += item.id + ',';
        }
        for (const item of state.destination_app) {
            dest += item.id + ',';
        }
        const res = await VariantService.getVariant(categories, sources, dest);
        if (res?.status) {
            setDataFirst(res.data);
            // setDataSecond(JSON.parse(JSON.stringify(res.data)));
        }
        setLoading(false);
    };

    const handleClick = (item, i) => {
        let index = state.variant[i].findIndex(i => i.bot_id === item.bot_id);
        if (index < 0) {
            state.variant[i].push(item);
        }
        else if (index > -1) {
            state.variant[i].splice(index, 1);
        }
        localStorage.setItem('variant_state', JSON.stringify(state));
        setState({ ...state });
    };

    const scrollUp = (e) => {
        e.currentTarget.parentElement.children[1].scrollBy({ behavior: 'smooth', left: -560 });
    };

    const scrollDown = (e) => {
        e.currentTarget.parentElement.children[1].scrollBy({ behavior: 'smooth', left: 560 });
    };

    return (
        <div className="vvariant">
            {loading ? <Spinner color="#002742" /> : dataFirst.length > 0 ?
                <div className="variant-scroll">
                    <button onClick={scrollUp}><KeyboardArrowLeft /></button>
                    <div className="vvariant-col" style={dataFirst.length < 2 ? { justifyContent: 'center' } : undefined}>
                        {dataFirst?.map((item, itemI) =>
                            <Card key={itemI} data={item} onClick={item => handleClick(item, 'first')}
                                selected={state.variant.first.find(i => i.bot_id === item.bot_id)} />
                        )}
                    </div>
                    <button onClick={scrollDown}><KeyboardArrowRight /></button>
                </div> :
                <div className="vvariant-notfound">
                    <div>{t(label + 'NOT-FOUND')}</div>
                    <div>{t(label + 'CHANGE-FILTER')}</div>
                </div>
            }
            {/* <div className="vplus">+</div>
            <div className="variant-scroll">
                <button onClick={scrollUp}><KeyboardArrowUp /></button>
                <div className="vvariant-col">
                    {dataSecond.map((item, itemI) => (
                        <Card key={itemI} data={item} selected={state.variant.second.find(i => i.bot_id === item.bot_id)}
                            onClick={item => handleClick(item, 'second')} />
                    ))}
                </div>
                <button onClick={scrollDown}><KeyboardArrowDown /></button>
            </div> */}
        </div>
    );
}
export default Variant;